exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pi-mcell[data-v-63effa7d]{display:inline-block;min-width:0}.pi-mcell__value[data-v-63effa7d]{font-weight:700;color:#1f2933;margin-right:4px}.pi-mcell__value.is-muted[data-v-63effa7d]{font-weight:600;color:#6b7280}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-63effa7d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/vue/pages/components/pi/piMetricCell.vue
// module id = 1656
// module chunks = 0